// Projects.jsx
import React, { useState } from "react";
import "../Styles/Projects.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Import project images
import Project1 from "../Image/1.jpeg";
import Project2 from "../Image/2.jpeg";
import Project3 from "../Image/3.jpeg";
import Project4 from "../Image/4.jpeg";
import Project5 from "../Image/5.jpeg";
import Project6 from "../Image/6.jpeg";
import Project7 from "../Image/7.jpeg";
import Project8 from "../Image/8.jpeg";
import Project9 from "../Image/9.jpeg";
import Project10 from "../Image/10.jpeg";
import Project11 from "../Image/11.jpeg";
import Project12 from "../Image/12.jpeg";

const Projects = () => {
  const { t } = useTranslation(); // translation hook
  const [selectedImage, setSelectedImage] = useState(null);
  const [showAll, setShowAll] = useState(false);

  // Translated project data
  const projectsData = [
    { id: 1, img: Project1, title: t("project_residential_build") },
    { id: 2, img: Project2, title: t("project_commercial") },
    { id: 3, img: Project3, title: t("project_renovation") },
    { id: 4, img: Project4, title: t("project_interior") },
    { id: 5, img: Project5, title: t("project_exterior") },
    { id: 6, img: Project6, title: t("project_office") },
    { id: 7, img: Project7, title: t("project_custom") },
    { id: 8, img: Project8, title: t("project_modern_house") },
    { id: 9, img: Project9, title: t("project_drywall") },
    { id: 10, img: Project10, title: t("project_wall_mounting") },
    { id: 11, img: Project11, title: t("project_construction_house") },
    { id: 12, img: Project12, title: t("project_renovation_home") },
  ];

  const visibleProjects = showAll ? projectsData : projectsData.slice(0, 8);

  const openToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="projects-page">
      {/* HEADER */}
      <div className="projects-header">
        <h1>{t("projects_title")}</h1>
        <p>{t("projects_desc")}</p>
        <Link to="/contact">
          <button onClick={openToTop} className="quote-btn">
            {t("projects_get_a_quote")}
          </button>
        </Link>
      </div>

      {/* GALLERY */}
      <div className="projects-grid">
        {visibleProjects.map((project) => (
          <div
            key={project.id}
            className="project-card"
            onClick={() => setSelectedImage(project.img)}
          >
            <img src={project.img} alt={project.title} loading="lazy" />
            <div className="overlay">
              <span>{project.title}</span>
            </div>
          </div>
        ))}
      </div>

      {/* SEE MORE / LESS */}
      <div className="toggle-btn">
        <button onClick={() => setShowAll(!showAll)}>
          {showAll ? t("see_less") : t("see_more")}
        </button>
      </div>

      {/* IMAGE MODAL */}
      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <span className="close">&times;</span>
          <img src={selectedImage} alt="Project view" />
        </div>
      )}
    </div>
  );
};

export default Projects;


// import React, { useState } from "react";
// import "../Styles/Projects.scss";
// import Project1 from "../Image/1.jpeg";
// import Project2 from "../Image/2.jpeg";
// import Project3 from "../Image/3.jpeg";
// import Project4 from "../Image/4.jpeg";
// import Project5 from "../Image/5.jpeg";
// import Project6 from "../Image/6.jpeg";
// import Project7 from "../Image/7.jpeg";
// import Project8 from "../Image/8.jpeg";
// import Project9 from "../Image/9.jpeg";
// import Project10 from "../Image/10.jpeg";
// import Project11 from "../Image/11.jpeg";
// import Project12 from "../Image/12.jpeg";
// import { Link } from "react-router-dom";

// const projectsData = [
//   { id: 1, img: Project1, title: "Residential Build" },
//   { id: 2, img: Project2, title: "Commercial Project" },
//   { id: 3, img: Project3, title: "Renovation" },
//   { id: 4, img: Project4, title: "Interior Work" },
//   { id: 5, img: Project5, title: "Exterior Design" },
//   { id: 6, img: Project6, title: "Office Construction" },
//   { id: 7, img: Project7, title: "Custom Build" },
//   { id: 8, img: Project8, title: "Modern House" },
//   { id: 9, img: Project9, title: "Drywall" },
//   { id: 10, img: Project10, title: "Wall Mounting" },
//   { id: 11, img: Project11, title: "Construction House" },
//   { id: 12, img: Project12, title: "Renovation Home" },
// ];

// const Projects = () => {
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [showAll, setShowAll] = useState(false);

//   const visibleProjects = showAll ? projectsData : projectsData.slice(0, 8);
//   const openToTop = () => {
//   window.scrollTo({
//     top: 0,
//     left: 0,
//     behavior: "smooth"
//   });
// }
//   return (
//     <div className="projects-page">
//       {/* HEADER */}
//       <div className="projects-header">
//         <h1>Our Projects</h1>
//         <p>
//           A selection of our construction, renovation, and design works. Built
//           with precision, quality, and trust.
//         </p>

//         <Link to="/contact"><button onClick={openToTop} className="quote-btn">Get a Quote</button></Link>
//       </div>

//       {/* GALLERY */}
//       <div className="projects-grid">
//         {visibleProjects.map((project) => (
//           <div
//             key={project.id}
//             className="project-card"
//             onClick={() => setSelectedImage(project.img)}
//           >
//             <img src={project.img} alt={project.title} loading="lazy" />
//             <div className="overlay">
//               <span>{project.title}</span>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* SEE MORE / LESS */}
//       <div className="toggle-btn">
//         <button onClick={() => setShowAll(!showAll)}>
//           {showAll ? "See Less" : "See More"}
//         </button>
//       </div>

//       {/* IMAGE MODAL */}
//       {selectedImage && (
//         <div className="image-modal" onClick={() => setSelectedImage(null)}>
//           <span className="close">&times;</span>
//           <img src={selectedImage} alt="Project view" />
//         </div>
//       )}
//     </div>
//   );
// };

// export default Projects;
